import { Box, Container, Typography } from '@mui/material';

/**
 * Header component for Let's Collaborate page
 *
 * @returns {JSX.Element} Header component with hero section
 */
function LetsCollaborateHeader() {
  return (
    <Box
      sx={{
        background:
          'linear-gradient(135deg, var(--color-secondary) 0%, var(--color-secondary) 100%)',
        color: 'var(--color-secondary-text)',
        py: 8,
        mb: 8,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'var(--color-primary)',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'var(--color-primary)',
        },
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h1"
          sx={{
            fontWeight: 600,
            fontSize: { xs: '2.5rem', md: '4rem' },
            fontFamily: '"Playfair Display", serif',
            textAlign: 'center',
            mb: 3,
          }}
        >
          Let's Collaborate
        </Typography>
        <Typography
          variant="h5"
          sx={{
            textAlign: 'center',
            maxWidth: '800px',
            mx: 'auto',
            color: 'rgba(255, 255, 255, 0.9)',
            lineHeight: 1.6,
          }}
        >
          Whether you're a consultant, services integrator, or organization
          seeking transformation, we have the perfect collaboration model for
          you.
        </Typography>
      </Container>
    </Box>
  );
}

export default LetsCollaborateHeader;
